import { type ReactNode } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import { Auth0Provider, User, type AppState } from "@auth0/auth0-react"
import { usersKeys } from "@apis/users/queryKeys"

export const Auth0ProviderWithNavigate = ({
  children,
}: {
  children: ReactNode
}) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
  const domain = import.meta.env.VITE_AUTH0_DOMAIN
  const redirectUrl = `${window.location.origin}/callback`

  const onRedirectCallback = (appState?: AppState, user?: User) => {
    queryClient.invalidateQueries({ queryKey: usersKeys.detail(user?.email) })
    const logOutUrl = localStorage.getItem("logOutUrl")
    localStorage.removeItem("logOutUrl")
    navigate(logOutUrl || appState?.returnTo || window.location.pathname)
  }

  if (!(domain && clientId && redirectUrl)) {
    return null
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUrl,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
